import { render, staticRenderFns } from "./Type-denounce-form.vue?vue&type=template&id=4a3322e4"
import script from "./Type-denounce-form.vue?vue&type=script&lang=js"
export * from "./Type-denounce-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports